import { render, staticRenderFns } from "./ShareQuizModal.vue?vue&type=template&id=326313ae&scoped=true&"
import script from "./ShareQuizModal.vue?vue&type=script&lang=js&"
export * from "./ShareQuizModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareQuizModal.vue?vue&type=style&index=0&id=326313ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326313ae",
  null
  
)

export default component.exports